import React from 'react';
import { ScrollView, View } from 'react-native';
import MenuInfoLayout from '../../AuxiliaryComponent/MenuLayoutSim/MenuInfoLayout';
import MenuServicesLayout from '../../../menuLayout/MenuServicesLayout';
import SimulatorsViewerArrangement from '../SimulatorsViewerArrangement';
import FullPageSimulator from '../FullPageSimulator';
import { Android, iMessage, the_services_menu_str } from '../../../../utils/DictionaryManagementUtils';
import { img_android_qab_services, img_ios_qab_services } from '../../../../utils/ImagesManagementUtils';
import ActionBarServicesLayout from '../../../menuLayout/ActionBarServicesLayout';

//= ========================================================================

const MenuToolsBarFP = ({
  globJSON, simPlatform, force_display, without_Top_title, isMenu, slideshowRefs = null,
}) => {
  const { layout_menu_screen } = globJSON.configurations.services.menu;
  const not_layout_menu = !layout_menu_screen && simPlatform !== iMessage;
  return (
    <SimulatorsViewerArrangement>
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        TopTitle={simPlatform !== iMessage && !without_Top_title && the_services_menu_str}
        WithImageBackground={not_layout_menu && (simPlatform === Android ? img_android_qab_services : img_ios_qab_services)}
        hidePhoneHeadLine={not_layout_menu}
        withOutTopVerticalLine
        hideArrow
        isMenu
        slideshowRefs={slideshowRefs}
        scrollDisabled={not_layout_menu}
      >
        {layout_menu_screen || simPlatform === iMessage ? (
          <View>
            {isMenu ? (
              <MenuInfoLayout
                globJSON={globJSON}
                simPlatform={simPlatform}
                force_display={force_display}
              />
            ) : (
              <MenuInfoLayout globJSON={globJSON} simPlatform={simPlatform} />
            )}
            <ScrollView
              vertical
              pagingEnabled={false}
              showsVerticalScrollIndicator={false}
              scrollEnabled
            >
              <MenuServicesLayout globJSON={globJSON} showAllServices />
            </ScrollView>
          </View>
        )
          : (
            <ActionBarServicesLayout
              globJSON={globJSON}
              simPlatform={simPlatform}
            />
          )}
      </FullPageSimulator>
    </SimulatorsViewerArrangement>
  );
};
export default MenuToolsBarFP;
